<div class="report-main">
  <app-newsreport [reportData]="data"></app-newsreport>
</div>
